
  /**
   * scoutbar.js 
   * @summary ScoutBar is a JavaScript library for developing user friendly, easy-to-use, scalable and highly customizable component for automating your navigation experience
   * @version v1.2.3
   * @author  Adenekan Wonderful <hellocodewonders@gmail.com> (https://codewonders.dev)
   * @license Released under the MIT license.
   * @copyright Adenekan Wonderful 2021
   */

import { getOS } from './index.js';

var SCOUTBAR_ROOT_ID = 'scoutbar___root';
var FOCUSABLE_ELEMENTS = "body > div:not(#" + SCOUTBAR_ROOT_ID + ")";
var ROOT_SHORTCUT = getOS() === 'Mac' ? ['meta', 'k'] : ['control', 'k'];

export { FOCUSABLE_ELEMENTS, ROOT_SHORTCUT, SCOUTBAR_ROOT_ID };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvY29uc3RhbnRzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGdldE9TIH0gZnJvbSAndXRpbHMnO1xuXG5leHBvcnQgY29uc3QgU0NPVVRCQVJfUk9PVF9JRCA9ICdzY291dGJhcl9fX3Jvb3QnO1xuZXhwb3J0IGNvbnN0IEZPQ1VTQUJMRV9FTEVNRU5UUyA9IGBib2R5ID4gZGl2Om5vdCgjJHtTQ09VVEJBUl9ST09UX0lEfSlgO1xuZXhwb3J0IGNvbnN0IFJPT1RfU0hPUlRDVVQgPVxuICBnZXRPUygpID09PSAnTWFjJyA/IFsnbWV0YScsICdrJ10gOiBbJ2NvbnRyb2wnLCAnayddO1xuIl0sIm5hbWVzIjpbIlNDT1VUQkFSX1JPT1RfSUQiLCJGT0NVU0FCTEVfRUxFTUVOVFMiLCJST09UX1NIT1JUQ1VUIiwiZ2V0T1MiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztJQUVhQSxnQkFBZ0IsR0FBRztJQUNuQkMsa0JBQWtCLHdCQUFzQkQsZ0JBQXRCO0lBQ2xCRSxhQUFhLEdBQ3hCQyxLQUFLLE9BQU8sS0FBWixHQUFvQixDQUFDLE1BQUQsRUFBUyxHQUFULENBQXBCLEdBQW9DLENBQUMsU0FBRCxFQUFZLEdBQVo7Ozs7In0=
